// https://stackoverflow.com/a/65586375/116051
export const file2Base64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve(
        reader.result?.toString().replace('data:', '').replace(/^.+,/, '') ||
          '',
      );
    reader.onerror = error => reject(error);
  });
};
